/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDto } from '../../models/document-dto';

export interface FixDocumentControllerFindEtcDocuments$Params {
  ticketId: string;
}

export function fixDocumentControllerFindEtcDocuments(http: HttpClient, rootUrl: string, params: FixDocumentControllerFindEtcDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentDto>>> {
  const rb = new RequestBuilder(rootUrl, fixDocumentControllerFindEtcDocuments.PATH, 'get');
  if (params) {
    rb.query('ticketId', params.ticketId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentDto>>;
    })
  );
}

fixDocumentControllerFindEtcDocuments.PATH = '/api/fix-document/etc';
